export const sizeEnums = Object.freeze({
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl',
  null: 'full'
})

export const sizeIconEnum = Object.freeze({
  ...sizeEnums,
  logo: 'logo',
  login: 'login',
  expanded: 'expanded',
  shareLogo: 'shareLogo'
})

export const colorsEnum = Object.freeze({
  gray: 'gray',
  white: 'white',
  danger: 'danger',
  warning: 'warning',
  primary: 'primary',
  inherit: 'inherit',
  success: 'success',
  secondary: 'secondary',
  transparent: 'transparent',
  lightPrimary: 'lightPrimary'
})

export const rotateEnum = Object.freeze({
  rot90: 'rot90',
  rot180: 'rot180',
  rot270: 'rot270'
})

export const windowsBreakPoints = Object.freeze({
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
})

export const themes = Object.freeze({
  mindfitTheme: 'mindfit_theme',
  impactivoTheme: 'impactivo_theme',
  drKeywordTheme: 'dr_keyword_theme'
})

export const variantsEnum = Object.freeze({
  info: 'info',
  dark: 'dark',
  light: 'light',
  white: 'white',
  danger: 'danger',
  primary: 'primary',
  success: 'success',
  warning: 'warning',
  secondary: 'secondary'
})

export const ButtonsEnum = Object.freeze({
  light: 'light',
  danger: 'danger',
  outline: 'outline',
  primary: 'primary',
  inactive: 'inactive',
  secondary: 'secondary',
  transparent: 'transparent'
})

export const InputsEnum = Object.freeze({
  block: 'block',
  border: 'border',
  inline: 'inline'
})

export const languages = Object.freeze({
  en: 'Ingles',
  es: 'Español'
})

export const sortEnum = Object.freeze({
  ASC: 'ASC',
  DES: 'DES',
  RND: 'RND'
})
